import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function Footer(): ReactNode {
	const { t } = useTranslation();
	return (
		<footer className="footer">
			<div className="wrap footer-inner">
				<div>
					<div className="brand" style={{ marginBottom: 6 }}>
						<span className="logo" aria-hidden="true">
							<svg viewBox="0 0 24 24" fill="none">
								<line x1="5" y1="6" x2="12" y2="12" stroke="var(--acc)" strokeWidth="1.4" />
								<line x1="19" y1="5" x2="12" y2="12" stroke="var(--acc)" strokeWidth="1.4" />
								<line x1="12" y1="12" x2="7" y2="19" stroke="var(--acc)" strokeWidth="1.4" />
								<line x1="12" y1="12" x2="18" y2="18" stroke="var(--acc2)" strokeWidth="1.4" />
								<circle cx="5" cy="6" r="2.4" fill="var(--acc)" />
								<circle cx="19" cy="5" r="2" fill="var(--acc)" />
								<circle cx="12" cy="12" r="2.8" fill="var(--acc-bright)" />
								<circle cx="7" cy="19" r="2" fill="var(--acc2)" />
								<circle cx="18" cy="18" r="2.2" fill="var(--acc2)" />
							</svg>
						</span>
						Graphless
					</div>
					<div className="meta">{t("footer.tagline")}</div>
				</div>
				<div className="footer-end">
					<a
						className="footer-social"
						href="https://x.com/graphless"
						target="_blank"
						rel="noopener noreferrer"
						aria-label={t("footer.xAria")}
					>
						<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
							<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
						</svg>
					</a>
					<div className="meta footer-copy">{t("footer.copyright")}</div>
				</div>
			</div>
		</footer>
	);
}
